import styled from 'styled-components'

import { Modal } from 'antd'
import { colors } from 'Styled/variables'

export const AntdModal = styled(Modal)``

export const ContentContainer = styled.div`
  padding: 24px;
  background-color: ${colors.white};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
`
